import React, { useState, useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Select from "react-select";
import DatePicker, { DateObject } from "react-multi-date-picker";
import TimePickerWrapper from '../../../components/Forms/Pickers/TimePicker';
import axios from 'axios';
import Swal from 'sweetalert2';

const Permission = ({ show, onClose, onSubmit, staffId, staffOptions, existingData = {} }) => {
    // const department = [
    //     { value: "1", label: "Management", },
    //     { value: "2", label: "Kitchen Management" },
    //     { value: "3", label: "Deliveri Mangement" },
    // ];
    // const staff = [
    //     { value: "1", label: "Siva Sakthi", },
    //     { value: "2", label: "Banu Priya" },
    //     { value: "3", label: "Deepak Kumar" },
    // ];
    // const options_del_point = [
    //     { value: "", label: "Select Delivery Point" },
    //     { value: "0", label: "Anna Nagar" },
    //     { value: "1", label: "Thallakulam" },
    //     { value: "2", label: "Anna Nagar" },
    //     { value: "3", label: "Thallakulam" },
    // ];
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [errors, setErrors] = useState({});
    const today = new DateObject();

    const [selectedOption, setSelectedOption] = useState(null);
    const staff = staffOptions.find((s) => s.id === staffId) || { name: 'Unknown', department: '-' };
    console.log('staffOptions:', staffOptions);
    console.log('staffId:', staffId);

    // State for single permission
    const [singleDate, setSingleDate] = useState(null);
    const [singleStartTime, setSingleStartTime] = useState('');
    const [singleEndTime, setSingleEndTime] = useState('');
    
    // State for future permissions
    const [permissions, setPermissions] = useState([
        { id: Date.now(), date: null, start_time: '', end_time: '' },
    ]);

    // State for checkboxes
    const [isConsiderAbsent, setIsConsiderAbsent] = useState(false);
    const [isFuturePermission, setIsFuturePermission] = useState(false);

    // State for reason
    const [reason, setReason] = useState('');

    // const [isFocused] = useState(false);
    // useEffect(() => {
    //     if (isFocused) {
    //         console.log('The input is focused!');
    //     }
    // }, [isFocused]);

    // const [isCheckedpass, setIsCheckedpass] = useState(false);

    // Checkbox handlers
    const handleCheckboxChangepass = (e) => {
        setIsConsiderAbsent(e.target.checked);
    };

    // const [isFuturePermissionChecked, setIsFuturePermissionChecked] = useState(false);

    const handleCheckboxForFuturePermission = (e) => {
        setIsFuturePermission(e.target.checked);
    };

    // const [permission, setPermission] = useState([{ id: Date.now() }]);
    // Add new IP configuration
    const handlePermissionChange = (id, field, value) => {
        setPermissions(
        permissions.map((config) =>
            config.id === id ? { ...config, [field]: value } : config
        )
        );
    };

    // Add a permission entry
    const handleAddConfig = () => {
        setPermissions([...permissions, { id: Date.now(), date: null, start_time: '', end_time: '' }]);
    };

    // Delete a permission entry
    const handleDeleteConfig = (id) => {
        setPermissions(permissions.filter((config) => config.id !== id));
    };

    useEffect(() => {
        if (existingData && show) {
            // If existingData has a single date permission
            if (existingData.date) {
            setSingleDate(new DateObject(existingData.date));
            } else {
            setSingleDate(null);
            }

            if (existingData.start_time) {
            setSingleStartTime(existingData.start_time);
            } else {
            setSingleStartTime('');
            }

            if (existingData.end_time) {
            setSingleEndTime(existingData.end_time);
            } else {
            setSingleEndTime('');
            }

            if (existingData.reason) {
            setReason(existingData.reason);
            } else {
            setReason('');
            }

            if (existingData.future_permission && existingData.future_permission === 1) {
            // Pre-fill future permissions if present
            const futurePermissions = existingData.dates?.map((date, idx) => ({
                id: Date.now() + idx,
                date: new DateObject(date),
                start_time: existingData.start_times?.[idx] || '',
                end_time: existingData.end_times?.[idx] || '',
            })) || [{ id: Date.now(), date: null, start_time: '', end_time: '' }];

            setPermissions(futurePermissions);
            setIsFuturePermission(true);
            } else {
            setPermissions([{ id: Date.now(), date: null, start_time: '', end_time: '' }]);
            setIsFuturePermission(false);
            }

            setIsConsiderAbsent(existingData.permision_absent === 1);
        }
        }, [existingData, show]);

    const handleSubmit = () => {
    const newErrors = {};

    if (!reason.trim()) {
        newErrors.reason = "This Field is required";
        }

        if (!isFuturePermission) {
            // Validate single permission fields
            if (!singleDate || !singleDate.isValid) {
                newErrors.singleDate = "This Field is required";
            }
            if (!singleStartTime) {
                newErrors.singleStartTime = "This Field is required";
            }
            if (!singleEndTime) {
                newErrors.singleEndTime = "This Field is required";
            }
            if (singleStartTime && singleEndTime && singleStartTime >= singleEndTime) {
                newErrors.timeOrder = "End time must be after start time";
            }
        } else {
            // Validate each future permission entry
            permissions.forEach((config) => {
                if (!config.date || !config.date.isValid) {
                    newErrors[`futureDate_${config.id}`] = "This Field is required";
                }
                if (!config.start_time) {
                    newErrors[`futureStartTime_${config.id}`] = "This Field is required";
                }
                if (!config.end_time) {
                    newErrors[`futureEndTime_${config.id}`] = "This Field is required";
                }
                if (
                    config.start_time &&
                    config.end_time &&
                    config.start_time >= config.end_time
                ) {
                    newErrors[`futureTimeOrder_${config.id}`] = "End Time must be after Start Time";
                }
            });
        }

        // If errors exist, update state and stop submission
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        // Build data for API
        if (!isFuturePermission) {
            const attendanceData = {
                attendance_type: 2,
                date: singleDate.format('YYYY-MM-DD'),
                start_time: singleStartTime,
                end_time: singleEndTime,
                permision_absent: isConsiderAbsent ? 1 : 0,
                reason: reason.trim(),
            };

            console.log('Submitting single permission:', attendanceData);
            onSubmit(attendanceData);
        } else {
            const attendanceData = {
                attendance_type: 2,
                future_permission: 1,
                dates: permissions.map((config) => config.date.format('YYYY-MM-DD')),
                start_times: permissions.map((config) => config.start_time),
                end_times: permissions.map((config) => config.end_time),
                permision_absent: isConsiderAbsent ? 1 : 0,
                reason: reason.trim(),
            };

            console.log('Submitting future permission:', attendanceData);
            onSubmit(attendanceData);
        }

        // Reset form
        setSingleDate(null);
        setSingleStartTime('');
        setSingleEndTime('');
        setPermissions([{ id: Date.now(), date: null, start_time: '', end_time: '' }]);
        setIsConsiderAbsent(false);
        setIsFuturePermission(false);
        setReason('');
        setErrors({});
        onClose();
    };

    return (
        <Modal show={show} size="lg">
            <div className="modal-content border border-red rounded-xxl">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Mark Permission Attendance</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row">
                        {/* <div className="col-lg-6 mb-2">
                            <label className="text-black font-w500 fs-7">Department<span className="required">*</span></label>
                            <Select placeholder='Select Department'
                                defaultValue={selectedOption}
                                onChange={setSelectedOption}
                                options={department}
                            />
                        </div> */}
                        {/* <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-4'>
                            <label className='text-gray-800 font-w500 fs-7'>Date</label>
                            <label className='text-danger fs-6 font-w600'>05-June-2025</label>
                        </div> */}
                        <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-4'>
                            <label className='text-gray-800 font-w500 fs-7'>Staff</label>
                            <label className='text-black fs-6 font-w500'>{staff.name}</label>
                        </div>
                        <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-4'>
                            <label className='text-gray-800 font-w500 fs-7'>Department</label>
                            <label className='text-black fs-6 font-w500'>{staff.department}</label>
                        </div>
                    </div>
                    {/* <div className="col-lg-6 mb-2">
                            <label className="text-black font-w500 fs-7">Staff<span className="required">*</span></label>
                            <Select placeholder='Select Staff'
                                isMulti
                                defaultValue={selectedOption}
                                onChange={setSelectedOption}
                                options={staff}
                            />
                        </div> */}
                    {!isFuturePermission && (
                        <div className='row'>
                            <div className="col-lg-4 mb-3">
                                <label className="text-black font-w500 fs-7">
                                    Date <span className="required">*</span>
                                </label>
                                <div className="datepicker-wrapper d-flex">
                                    <div className="input-group-text bg-transparent border-0 px-0">
                                        <i className="fa-solid fa-calendar-days fs-4"></i>
                                    </div>
                                    <DatePicker
                                        placeholder="Select Date"
                                        value={singleDate}
                                        onChange={(date) => {
                                        console.log('Single date selected:', date);
                                        setSingleDate(date);
                                        }}
                                        format="DD-MM-YYYY"
                                        minDate={today}
                                        mapDays={({ date }) => {
                                            const day = date.weekDay.index; // 0 = Sunday, 1 = Monday, ..., 6 = Saturday
                                            if (day === 0) {
                                            return {
                                                disabled: true,
                                                style: { color: "#ccc", textDecoration: "line-through" }, // Optional styling
                                            };
                                            }
                                        }}
                                    />
                                </div>
                                {errors.singleDate && <div className="text-danger fs-7 mt-1">{errors.singleDate}</div>}
                            </div>
                            <div className="col-lg-4 mb-3">
                                <label className="text-black font-w500 fs-7">
                                    Permission Start Time <span className="required">*</span>
                                </label>
                                <div>
                                    <TimePickerWrapper 
                                    value={singleStartTime}
                                    onChange={(time) => {
                                    console.log('Single start time:', time);
                                    setSingleStartTime(time);
                                    }}
                                    />
                                    {errors.singleStartTime && <div className="text-danger fs-7 mt-1">{errors.singleStartTime}</div>}
                                </div>
                            </div>
                            <div className="col-lg-4 mb-3">
                                <label className="text-black font-w500 fs-7">
                                    Permission End Time <span className="required">*</span>
                                </label>
                                <div>
                                    <TimePickerWrapper 
                                    value={singleEndTime}
                                    onChange={(time) => {
                                    console.log('Single end time:', time);
                                    setSingleEndTime(time);
                                    }}
                                    />
                                    {errors.singleEndTime && <div className="text-danger fs-7 mt-1">{errors.singleEndTime}</div>}
                                </div>
                            </div>
                        </div>
                    )}

                    <div className='row'>
                        <div className="col-lg-4 mb-3">
                            <label className="text-black font-w500 fs-7"><input
                                type="checkbox"
                                checked={isConsiderAbsent}
                                onChange={handleCheckboxChangepass}
                                className="form-check-input me-2 mt-0"
                                id="customCheckBox2"
                                required
                            />Consider as Absent
                            </label>
                        </div>
                        <div className="col-lg-4 mb-3">
                            <label className="text-black font-w500 fs-7">
                                <input
                                    type="checkbox"
                                    checked={isFuturePermission}
                                    onChange={handleCheckboxForFuturePermission}
                                    className="form-check-input me-2 mt-0"
                                    id="customCheckBox3"
                                />
                                Mark Future Permission
                            </label>
                        </div>
                    </div>
                    {isFuturePermission && (
                        <div className='row'>
                            <div className='scroll-y mh-250px py-2 '>
                                {permissions.map((config, index) => (
                                    <div key={config.id} data-repeater-item>
                                        <div className="row align-items-end ">
                                            <div className="col-lg-3 mb-3">
                                                <label className="text-black font-w500 fs-7">
                                                    Date <span className="required">*</span>
                                                </label>
                                                <div className="datepicker-wrapper d-flex">
                                                    <div className="input-group-text bg-transparent border-0 px-0">
                                                        <i className="fa-solid fa-calendar-days fs-4"></i>
                                                    </div>
                                                    <DatePicker
                                                        placeholder="Select Date"
                                                        value={config.date}
                                                        onChange={(date) => {
                                                        console.log(`Future date for ${config.id}:`, date);
                                                        handlePermissionChange(config.id, 'date', date);
                                                        }}
                                                        format="DD-MM-YYYY"
                                                        minDate={today}
                                                        mapDays={({ date }) => {
                                                            const day = date.weekDay.index; // 0 = Sunday, 1 = Monday, ..., 6 = Saturday
                                                            if (day === 0) {
                                                            return {
                                                                disabled: true,
                                                                style: { color: "#ccc", textDecoration: "line-through" }, // Optional styling
                                                            };
                                                            }
                                                        }}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-lg-3 mb-3">
                                                <label className="text-black font-w500 fs-7">
                                                    Permission Start Time <span className="required">*</span>
                                                </label>
                                                <div>
                                                    <TimePickerWrapper 
                                                    value={config.start_time}
                                                    onChange={(time) => {
                                                    console.log(`Start time for ${config.id}:`, time);
                                                    handlePermissionChange(config.id, 'start_time', time);
                                                    }}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-lg-3 mb-3">
                                                <label className="text-black font-w500 fs-7">
                                                    Permission End Time <span className="required">*</span>
                                                </label>
                                                <div>
                                                    <TimePickerWrapper 
                                                    value={config.end_time}
                                                    onChange={(time) => {
                                                    console.log(`End time for ${config.id}:`, time);
                                                    handlePermissionChange(config.id, 'end_time', time);
                                                    }}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-lg-3 mb-3  d-flex justify-content-start">
                                                {permissions.length > 1 && (
                                                    <button
                                                        className="btn btn-danger px-2 py-2"
                                                        onClick={() => handleDeleteConfig(config.id)}
                                                        data-bs-toggle="tooltip"
                                                        data-bs-placement="top"
                                                        title="Delete"
                                                    >
                                                        <i className="fa-solid fa-trash-can fs-6 mt-1 text-white"></i>
                                                    </button>
                                                )}

                                                {/* Show Add More button only for the last permission item */}
                                                {index === permissions.length - 1 && (
                                                    <button
                                                        className="btn btn-sm btn-primary ms-3 px-2 py-2"
                                                        onClick={handleAddConfig}
                                                        type="button"
                                                    >
                                                        <i className="fa-solid fa-plus fs-6"></i>
                                                        {/* <span className="ms-2 fs-7">Add More</span> */}
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}



                    <div className='row'>
                        <div className="col-lg-12 mb-3">
                            <label className="text-black font-w500 fs-7">Reason</label>
                            <textarea rows={8} className="form-control" name="comment" placeholder="Reason" value={reason}
                            onChange={(e) => setReason(e.target.value)} />
                            {errors.reason && <div className="text-danger fs-7 mt-1">{errors.reason}</div>}
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-center gap-3 mt-4 mb-4">
                        <button type="reset" className="btn btn-sm btn-secondary" onClick={onClose}>Cancel</button>
                        <button type="submit" className="btn btn-sm btn-primary" onClick={handleSubmit}>Mark Permission Attendance</button>
                    </div>
                </div>

            </div>
        </Modal >
    );
};

export default Permission;
